import { getNotificationAdapter } from "./adapters/notification-adapter-factory";
import type { ApplicationNotification, NotificationViewModel } from "./notifications-panel.types";

export { getNotificationAdapter } from "./adapters/notification-adapter-factory";

export const adaptNotification = (notification: ApplicationNotification): NotificationViewModel => ({
  adapter: getNotificationAdapter(notification),
  createdAt: notification.createdAt ?? (notification.timestamp ? new Date(notification.timestamp).toISOString() : new Date().toISOString()),
  id: notification.id,
  isNew: notification.isNew,
  notification,
});
